import React, {useCallback} from 'react'

import {useShallowEqualSelector} from 'custom-hooks'
import {getProfileDataSelector} from 'redux/reducers/profile'
import SelectForHelpSupport from 'components/CommonUI/SelectForHelpSupport/SelectForHelpSupport'

const SelectFor = ({onChange, value}) => {
    const facilityList = useShallowEqualSelector(getProfileDataSelector)
    const locationList = facilityList.locations

    const listLocation = locationList.map(
        ({ name, id }) => ({ label:name, id })
    );


    const handleChange = useCallback((value) => {
        onChange('location', value)
    }, [onChange])

    return (
        <SelectForHelpSupport
            label="Select facility"
            emptyValue={value}
            dataList={listLocation}
            handleChange={handleChange}
            selectedValue={value}
        />
    )
}

export default SelectFor